import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class HeatindexDataService {
  combinedTimeStampList: any;
  mandalData: Object;
  urlConst: any = environment.url.HEATWAVE_STAGING_API_URL

  constructor(private http: HttpClient, private utils: UtilsService, private datePipe: DatePipe) { }

  getActualData(postData) {
    let url: any;
    url = this.urlConst + 'heatWatches/getObservedHeatWatchesData';
    return this.http.post<any>(url, postData);
  }

  getDistrictData(postData) {
    let url: any;
    url = this.urlConst + 'heatWatches/getHeatWatchesData';
    return this.http.post<any>(url, postData);
  }

  getHeirarchy(postData) {
    let url = this.urlConst + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }

  getTableDistrictData(postData) {
    let url = this.urlConst + "heatWatches/getHeatWatchesCount";
    return this.http.post<any>(url, postData);
  }

  getPostDataForHI(queryParams) {
    const today = new Date();
    const startTs = today.getTime()
    const endTs = today.getTime() + (6 * 24 * 60 * 60 * 1000);
    let distUUID;
    let stateUUID;
    if (queryParams['locType'] == 'DISTRICT') {
      let allLocations = queryParams['location'].split('&')
      stateUUID = allLocations[1].split('##')[1]
      distUUID = allLocations[2].split('##')[1]
    }
    let postData = {
      component: "HEATINDEX",
      "sUUID": queryParams['locType'] != 'DISTRICT' ? '00cb31c7-2928-4e6d-adcc-443d478c90d6' : stateUUID,
      "pUUID": queryParams['locType'] != 'DISTRICT' ? '00cb31c7-2928-4e6d-adcc-443d478c90d6' : distUUID,
      "pType": queryParams['locType'] != 'DISTRICT' ? "COUNTRY" : "DISTRICT",
      "cType": queryParams['locType'] != 'DISTRICT' ? "DISTRICT" : "BLOCK",
      "source": 'IMD_LONG_RANGE',
      "startTs": startTs,
      "endTs": endTs
    }

    return postData
  }

  formatStateData(data, locType) {
    locType = this.toTitleCase(locType)
    let finalData = {};
    let timeStampList = []
    let table_data = []
    for (let locName in data) {
      let locObject = {}
      locObject[locType] = { val: this.utils.formatNames(data[locName]['name']) };
      locObject['uuid'] = data[locName]['uuid'];
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let timeC = timeStamp.toString() + "_" + "vh";
        locObject[timeC] = { val: data[locName]['table_data'][element]['data']['vh'] };
        let timeD = timeStamp.toString() + "_" + "h";
        locObject[timeD] = { val: data[locName]['table_data'][element]['data']['h'] };
        let timeE = timeStamp.toString() + "_" + "w";
        locObject[timeE] = { val: data[locName]['table_data'][element]['data']['w'] };
        let timeF = timeStamp.toString() + "_" + "sw";
        locObject[timeF] = { val: data[locName]['table_data'][element]['data']['sw'] };
        let timeG = timeStamp.toString() + "_" + "n";
        locObject[timeG] = { val: data[locName]['table_data'][element]['data']['n'] };
      }
      // console.log(data[locName]);
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_data.push(locObject);
    }
    let sortedTimeStampList = timeStampList.sort()
    let column1 = [];
    column1.push({
      val: locType,
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: locType,
    })
    let column2 = [];
    let tableHeaders = [];
    tableHeaders.push({ val: locType });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      column1.push({
        val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: 5,
        rowspan: 1,
        sortedHeaderVal: tp.toString() + "_h"
      })
      column2.push({
        val: 'Extreme Danger',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.very_hot,
        sortedHeaderVal: tp.toString() + "_vh",
        color: 'black'
      })
      column2.push({
        val: 'Danger',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
        sortedHeaderVal: tp.toString() + "_h"
      })
      column2.push({
        val: 'Extreme Caution',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.warm,
        sortedHeaderVal: tp.toString() + "_w"
      })
      column2.push({
        val: 'Caution',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.slightly_warm,
        sortedHeaderVal: tp.toString() + "_sw"
      })
      column2.push({
        val: 'Normal',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.normal,
        sortedHeaderVal: tp.toString() + "_n"
      })
      tableHeaders.push({
        val: tp.toString() + "_vh"
      })
      tableHeaders.push({
        val: tp.toString() + "_h"
      })
      tableHeaders.push({
        val: tp.toString() + "_w"
      })
      tableHeaders.push({
        val: tp.toString() + "_sw"
      })
      tableHeaders.push({
        val: tp.toString() + "_n"
      })
    }
    let tableColumns = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatChartData(data, chartDataString) {
    let timeStampList = []
    let blockArray = []
    let formattedChartData = [{}, {}, {}, {}, {}];
    formattedChartData[0][chartDataString] = "Extreme Danger";
    formattedChartData[1][chartDataString] = "Danger";
    formattedChartData[2][chartDataString] = "Extreme Caution";
    formattedChartData[3][chartDataString] = "Caution";
    formattedChartData[4][chartDataString] = "Normal";
    let chartData = {
      "ExtremeDanger": {},
      "Danger": {},
      "ExtremeCaution": {},
      "Caution": {},
      "Normal": {}
    };
    let count = 0;
    for (let locName in data) {
      let locObject = {}
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let date = this.utils.convertModelDatetoDate(timeStamp).toLocaleDateString();
        if (chartData["ExtremeDanger"][date] == undefined && formattedChartData[0][date] == undefined) {
          chartData["ExtremeDanger"][date] = data[locName]['table_data'][element]['data']['vh'];
          formattedChartData[0][date] = data[locName]['table_data'][element]['data']['vh'];
        }
        else {
          chartData["ExtremeDanger"][date] += data[locName]['table_data'][element]['data']['vh'];
          formattedChartData[0][date] += data[locName]['table_data'][element]['data']['vh'];
        }
        if (chartData["Danger"][date] == undefined && formattedChartData[1][date] == undefined) {
          chartData["Danger"][date] = data[locName]['table_data'][element]['data']['h'];
          formattedChartData[1][date] = data[locName]['table_data'][element]['data']['h'];
        }
        else {
          chartData["Danger"][date] += data[locName]['table_data'][element]['data']['h'];
          formattedChartData[1][date] += data[locName]['table_data'][element]['data']['h'];
        }
        if (chartData["ExtremeCaution"][date] == undefined && formattedChartData[2][date] == undefined) {
          chartData["ExtremeCaution"][date] = data[locName]['table_data'][element]['data']['w'];
          formattedChartData[2][date] = data[locName]['table_data'][element]['data']['w'];
        }
        else {
          chartData["ExtremeCaution"][date] += data[locName]['table_data'][element]['data']['w'];
          formattedChartData[2][date] += data[locName]['table_data'][element]['data']['w'];
        }
        if (chartData["Caution"][date] == undefined && formattedChartData[3][date] == undefined) {
          chartData["Caution"][date] = data[locName]['table_data'][element]['data']['sw'];
          formattedChartData[3][date] = data[locName]['table_data'][element]['data']['sw'];
        }
        else {
          chartData["Caution"][date] += data[locName]['table_data'][element]['data']['sw'];
          formattedChartData[3][date] += data[locName]['table_data'][element]['data']['sw'];
        }
        if (chartData["Normal"][date] == undefined && formattedChartData[4][date] == undefined) {
          chartData["Normal"][date] = data[locName]['table_data'][element]['data']['n'];
          formattedChartData[4][date] = data[locName]['table_data'][element]['data']['n'];
        }
        else {
          chartData["Normal"][date] += data[locName]['table_data'][element]['data']['n'];
          formattedChartData[4][date] += data[locName]['table_data'][element]['data']['n'];
        }
      }
      count = count + 1;
    }
    let sortedTimeStampList = timeStampList.sort()
    for (let tp of sortedTimeStampList) {
      blockArray.push(this.utils.convertModelDatetoDate(tp).toLocaleDateString());
    }
    return [chartData, formattedChartData, blockArray, count];
  }

  formatMandalData(data, hval, hcat, gis, actualData?) {
    let totalTableData: any;
    // if (actualData.length > 0) {
    //   totalTableData = this.fetchTotData(actualData, data);
    // } else {
    // totalTableData = data
    // }
    return new Promise((resolve, reject) => {
      const finalData = {};
      const timeStampList = [];
      let currentDate = this.getCurrentDateInYYYYMMDDFormat();
      for (const locName of Object.keys(data)) {
        if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
          continue;
        }
        let table_data = {};
        for (const index of data[locName]['table_data']) {
          if (!timeStampList.includes(index['timeStamp'])) {
            timeStampList.push(index['timeStamp']);
          }
          if (index['timeStamp'] == currentDate && data[locName]['table_data'].length > 0) {
            // for (let actualLocName of Object.keys(data)) {
            // if (data[actualLocName]['uuid'] == data[locName]['uuid']) {
            for (let i in data[locName]['table_data']) {
              if (index['timeStamp'] == data[locName]['table_data'][i]['timeStamp']) {
                table_data[index['timeStamp']] = {
                  val: data[locName]['table_data'][i]['data'][hval],
                  cat: data[locName]['table_data'][i]['data'][hcat]
                };
              }
            }
            // }
            // }

          } else {
            table_data[index['timeStamp']] = {
              val: index['data'][hval],
              cat: index['data'][hcat]
            };
          }
        }
        const locData = {
          name: data[locName].name,
          pName: data[locName].pName,
          uuid: data[locName].name,
          'table_data': table_data
        };
        finalData[data[locName].uuid] = locData;
      }
      const sortedTimeStampList = this.combinedTimeStampList.sort();
      // const sortedTimeStampList = timeStampList.sort();
      gis.labelStrings = this.createLabels(sortedTimeStampList);
      // let index: any = this.setBlockNumber();
      gis.activeGroup = sortedTimeStampList[0];
      resolve(finalData);
    })
  }

  formatMandalDataForTable(data, hval, hcat, component?) {
    let finalData = {};
    let table_dataForMandal = [];
    let timeStampList = [];
    for (let locName of Object.keys(data)) {
      if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
        continue;
      }
      let locObject = {};
      for (let index of data[locName]['table_data']) {
        if (!timeStampList.includes(index['timeStamp'])) {
          timeStampList.push(index['timeStamp']);
        }
        if (!(Number(index['data'][hval]).toFixed(2) == "NaN")) {
          locObject[index['timeStamp']] = {
            val: Number(index['data'][hval]).toFixed(2),
            backgroundColor: component == 'HEATINDEX' ? ProjConstants.HEAT_INDEX_LEGEND[index['data'][hcat]] : ProjConstants.HEAT_WATCHES_LEGEND[index['data'][hcat]],


          }
        }
      }
      // locObject['District'] = { val: this.utils.formatNames(data[locName]['pName']) }
      locObject['Mandal'] = { val: this.utils.formatNames(data[locName]['name']) }
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_dataForMandal.push(locObject)
    }
    let sortedTimeStampList = timeStampList.sort();
    let column1 = [];
    column1.push({
      val: 'Mandal',
      colspan: 1,
      rowspan: 1,
      sortedHeaderVal: 'Mandal',
    })
    // column1.push({
    //   val: 'District',
    //   colspan: 1,
    //   rowspan: 1,
    //   sortedHeaderVal: 'District',
    // })
    let tableHeaders = [];
    tableHeaders.push({ val: 'Mandal' });
    // tableHeaders.push({ val: 'District' });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      column1.push({
        val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: tp.toString()
      })
      tableHeaders.push({
        val: tp.toString()
      })
    }
    let tableColumns = []
    tableColumns.push(column1);
    finalData['data'] = table_dataForMandal;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  fetchTotData(dataA: any, dataB: any) {
    let objA: any = this.fetchObj(dataA);
    let objB: any = this.fetchObj(dataB);
    let keys: any = Object.keys(objA);
    let finalArr: any = [];
    let obj: any = {}
    for (let i: any = 0; i < keys.length; i++) {
      let obj: any = {};
      obj = { ...obj, ...objA[keys[i]] };
      let newArr: any = [];
      newArr = newArr.concat(objA[keys[i]]['table_data']);
      if (!isNullOrUndefined(objB[keys[i]])) {
        newArr = newArr.concat(objB[keys[i]]['table_data']);
      }
      obj['table_data'] = this.removeDuplicates(newArr);

      finalArr.push(obj);
    }
    return finalArr;
  }

  fetchObj(data: any) {
    let obj: any = {};
    for (let i: any = 0; i < data.length; i++) {
      obj[data[i]['uuid']] = data[i];
    }

    return obj;
  }

  removeDuplicates(data: any) {
    const uniqueTimestamps = new Set<number>();
    const filteredData = data.filter(item => {
      if (!uniqueTimestamps.has(item.timeStamp)) {
        uniqueTimestamps.add(item.timeStamp);
        return true;
      }
      return false;
    });
    return filteredData;
  }

  getCurrentDateInYYYYMMDDFormat() {
    const currentDate = new Date();
    const threeDaysAgo = new Date(currentDate);
    // threeDaysAgo.setDate(currentDate.getDate() - 3); // Set date to three days ago

    const year = threeDaysAgo.getFullYear();
    const month = String(threeDaysAgo.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(threeDaysAgo.getDate()).padStart(2, '0');

    const formattedDate = `${year}${month}${day}`;
    return formattedDate;
  }

  createLabels(tsList) {
    const labelStrings = [];
    let device = this.utils.getDeviceType()
    let labels
    for (const ts of tsList) {
      if (device == 'mobile') {
        labels = this.utils.convertModelDatetoDateForMobile(ts)
        labels = this.datePipe.transform(labels, "dd/MM")
      }
      else if (device == 'desktop') {
        labels = this.utils.convertModelDatetoDate(ts).toLocaleDateString()
      }
      labelStrings.push({
        groupName: ts,
        label: {
          label: labels,
          toolTip: '5:30 AM - 5:30 AM'
        },
        fullLabel: labels
      });
    }
    return labelStrings;
  }

  setBlockNumber() {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    let index;

    if (currentHour > 17 || (currentHour === 17 && currentMinutes >= 30)) {
      // After 5:30 PM
      index = 3;
    } else {
      // Before 5:30 PM
      index = 2;
    }
    return index;
  }

  getChartData(categories, chartData, params) {
    let locType = params['locType'] != 'STATE' ? 'Districts' : 'Blocks'
    let options: object = {
      chart: {
        type: 'column',
        backgroundColor: '#000000' // or any hex, rgb, or rgba value
      },
      title: {
        text: '',
        style: {
          color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
        }
      },
      xAxis: {
        categories: categories,
        // title: {
        //   text: 'Dates',
        //   style: {
        //     color: '#ffffff'
        //   }
        // },
        labels: {
          style: {
           color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', // x-axis label color
          }
        },
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: 'No of ' + locType,
          style: {
           color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        labels: {
          style: {
           color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', // x-axis label color
          }
        },
        gridLineColor: '#808080'
        // stackLabels: {
        //   enabled: true,
        //   style: {
        //     fontWeight: 'bold'
        //   }
        // }
      },
     legend: {
        enabled: true,
         layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemMarginTop: 4,
  itemMarginBottom: 4,
  symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
            fontSize: '12px',
    fontWeight: 'normal'
           }
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true
          }
        }
      },
      series: [
        {
          name: 'Extreme Danger',
          type: 'column',
          data: categories.map(date => chartData.ExtremeDanger[date] || 0),
          color: '#ff0000'
        },
        {
          name: 'Danger',
          type: 'column',
          data: categories.map(date => chartData.Danger[date] || 0),
          color: '#ff7c00'
        },
        {
          name: 'Extreme Caution',
          type: 'column',
          data: categories.map(date => chartData.ExtremeCaution[date] || 0),
          color: '#ffdd00'
        },
        {
          name: 'Caution',
          type: 'column',
          data: categories.map(date => chartData.Caution[date] || 0),
          color: '#f3f8dc'
        },
        {
          name: 'Normal',
          type: 'column',
          data: categories.map(date => chartData.Normal[date] || 0),
          color: '#9edbab'
        }
      ],
      credits: {
        enabled: false
      }
    }
    return options;
  }

  toTitleCase(str: string) {
    const strng = [];
    str.split(' ').forEach((st: string) => {
      strng.push(st[0].toUpperCase() + st.substr(1).toLowerCase());
    });
    return strng.join(' ');
  }

}
